<template>
  <div>
    <section class="">
        <div class="flex-row section-container flex-justify-center">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
                <h2 class="section-title text-align-center">Background</h2>
                <h3>{{ heroName }}</h3>
            </div>
            <p class="text-align-center hero-bio" v-html="heroBackground"></p>
        </div>
    </section>
    <section class="">
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
            <h2 class="section-title text-align-center">Unique Attributes</h2>
            <div class="flex-row flex-row-gap card-container">
                    <template v-for="item in cards">
                        <card 
                            class="card landing-cards news-card neutral no-padding">
                            <div class="flex flex-row">
                                <div class="flex-column">
                                    <h3 class="card-title">{{item.title}}</h3>
                                    <ul class="hi-ul odd">
                                        <template v-for="listItem in item.list">
                                            <li class="li-diamond">{{listItem}}</li>
                                        </template>
                                    </ul>
                                </div>
                                <svg-icon-container   
                                    v-if="item.bodySvg"
                                    class="bodySvg"
                                    :hidden="false"
                                    :icon="item.bodySvg">
                                </svg-icon-container>
                            </div>
                        </card>
                    </template>
                </div>
            </div>
        </div>
    </section>
    <section class="">
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
                <h2 class="section-title text-align-center">Weapons</h2>
                <div class="flex-row flex-row-gap card-container">
                    <template v-for="item in weapons">
                        <card 
                            class="card landing-cards news-card weapon-card neutral no-padding">
                            <div class="flex flex-row flex-justify-center">
                                <div class="flex-column flex-item-center">
                                    <h3 class="card-title">{{item.title}}</h3>
                                    <img class="weapon-img" :src="getImgUrl(item.img)" />
                                </div>
                            </div>
                        </card>
                    </template>
                </div>
            </div>
        </div>
    </section>
    <section class="">
        <div class="flex-row section-container">
            
        </div>
    </section>
    <section id="about" class="">
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper width-100">
                <h2 class="section-title text-align-center">Moveset</h2>
            </div>
            <template v-for="move in youTubeVids">
                <div class="flex-row flex-grow flex-item-center text-align-center moveset-container width-100">
                        <div class="flex-column section-info moveset-info flex-1">
                            <p>
                                {{ move.snippet.title }}
                            </p>
                        </div>
                        <div class="flex-column flex-1 video-gallery flex-item-center">
                            <div class="video-container">
                                <div>
                                    <iframe :src="'https://www.youtube.com/embed/' + move.snippet.resourceId.videoId" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                </div>
            </template>
        </div>
    </section>
  </div>
</template>
<script>
import { SvgIconContainer } from "@/components";
import generalServices from '../services/GeneralServices';

const API_KEY = 'AIzaSyD0UfKWgvTfaDK5bq-kgaXa2c48ZDtVZh0';
const PLAYLIST_ID = 'PLXOxTWaPURjHmCu9UQ8KZr10ya9O2IQ-q'

export default {
  components: {
    'svg-icon-container': SvgIconContainer,
  },
  mixins: [],
  data() {
    return {
      heroName: "Govenor Amador",
      heroBackground: "Cunning yet cut-throat diplomat. <br><br> In a period of exploration and growth, newcomers from the sea offered to protect shipping routes across the unmapped West Demurgia. They were led by the intrepid Kerric Amador who founded the Freewinds Trading Company and secured Governorship in 162 A.I. <br><br> Nestling in coves and protected by dense jungles, bustling port cities like Emerald Bay popped up across the western seas. West Demurgia was a bountiful ocean, vast, but lacked large islands. <br><br> Then came the Newlanding Crisis; Amador's successor took advantage of broader political chaos breaking out in 168 A.I. With Kyn distracted by Minerva and Hotonotochi's wars, Amador spread instabiltiy across the Kyn's hinterland and set in motion Kyn's assassination. All the while playing diplomacy with the other realms. <br><br> Amador secured more land for their people, and forged a rapid peace with Kyn's successor who was eager to maintain stability. This set West Demurgia on a path of nation-building that would eventually lead to the Council of the Crowned.",
      cards: [
        {
            'title': 'Expansionist',
            'list': [
                "10% cheaper barracks",
                "5% less HP on all other buildings"
            ],
        },
        {
            'title': 'Tropical culture',
            'list': [
                "5% faster wood gathering",
                "20% less armor on all units"
            ],
        },
      ],
      weapons: [
        {
            'img': 'AmadorSword',
            'title': 'Cutlass',
        },
        {
            'img': 'AmadorPistol',
            'title': 'Pistol',
        },
      ],
      youTubeVids: [],
    };
  },
  created () {
    
  },
  mounted() {
    this.getYouTubeVids();
  },
  filters: {
    
  },
  computed: {
    
  },
  methods: {
    getImgUrl(picName) {
        var images = require.context('../assets/img/', false, /\.png$/)
        return images('./' + picName + ".png")
    },
    async getYouTubeVids() {
        try {
            let response = await generalServices.GET_DATA(`https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${PLAYLIST_ID}&maxResults=50&key=${API_KEY}`);
            this.youTubeVids = response.data.items;
        } catch (err) {
            console.log(err);
        }
    },
  }
};</script>
<style lang="scss">
</style>
